module.exports = __webpack_public_path__ + "img/register2.f3018ab7.png";